module.exports = "<div class=\"editorUi-modalContent\" @click.stop>\n  <div class=\"editorUi-error-message\">\n    <p>\n      There must be at least one section on a page.\n    </p>\n  </div>\n  <div class=\"editorUi-errorOption\">\n    <button class=\"editorUi-errorBtn\" @click=\"$emit('close-error')\">Ok</button>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/droplets/section/components/error-modal/template.html
// module id = aNp4
// module chunks = 0